import {Inject, Injectable} from '@angular/core';
import {RestEndPoints, ServerConstants, UserService, BffClientService} from "common-domain";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthService} from "common-domain";
import {AppConfigService} from 'common-domain';
import {User} from '@iana-rzms/bff-sdk';
import {from} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TldManagerUserService extends UserService {


  constructor(
    @Inject(HttpClient) http,
    @Inject('env') environment,
    @Inject(AuthService) auth,
    @Inject(AppConfigService) config,
    @Inject(BffClientService) bffClientService: BffClientService
  ) {
    super(http, environment, auth, config, bffClientService);
  }

  initResetPassword(userName: string) {
    return from(User.initiateResetPassword(this.sdkOptions({
      body: { username: userName }
    })));
  }

  resetOrCreatePassword(newPassword: string, correlationId: string, create: boolean, mfaToken: string) {
    if (create) {
      return this.createPassword(newPassword);
    } else {
      return this.resetPassword(newPassword, correlationId, mfaToken);
    }
  }

  resetPassword(newPassword: string, correlationId: string, mfaTokenJwt: string) {
    return from(User.resetPassword(this.sdkOptions({
      body: {
        newPassword,
        correlationId,
        mfaTokenJwt
      }
    })));
  }

  private createPassword(newPassword: string) {
    return from(User.createPassword(this.sdkOptions({
      body: {
        newPassword: newPassword
      }
    })));
  }

  recoveryUserName(email: string, password: string) {
    return from(User.recoverUserName(this.sdkOptions({
      body: {
        email: email,
        password: password
      }
    })));
  }


  getCurrentUserFromHeaderToken() {
    const url = this.getRestEndPoint() + RestEndPoints.GET_CURRENT_USER_UNAUTHENTICATED_REQUEST;
    return this.getResponseUnAuthenticatedRequest(url);
  }
}
